import { Location } from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthAuthService } from '../services/auth-auth.service';

@Injectable()
export class HttpUnauthorizedInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private location = inject(Location);
  private authenticationService = inject(AuthAuthService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
            // Do stuff with response if you want
          }
        },
        (err: unknown) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              if (err.url?.endsWith('/tirepd-api/organisation')) {
                this.authenticationService.logout('public/disabled-user');
              } else if (this.router.routerState.snapshot.url) {
                this.authenticationService.logout();
              }

              return throwError(err);
            }
          }
        }
      )
    );
  }
}
